import { action } from "satcheljs";

const initializeTimeoffRequest = action(
    "INITIALIZE_TIMEOFF_REQUEST", () => ({})
);

export default initializeTimeoffRequest;
